/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/naming-convention */
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { StatusValidationError } from 'shared/errors/validationError'
import { recoverUserFromStorage } from 'modules/auth/hooks/auth'

export const client: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
})

const trocaGestorPath = 'reset-register'

export const settingInterceptor = (
  access_token: string,
  chave: string,
  signIn: any,
  signOut: any,
  pathName: string,
): void => {
  client.defaults.headers.authorization = `Bearer ${access_token}`
  client.interceptors.response.use(undefined, async error => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      const { refresh_token } = recoverUserFromStorage(chave)
      if (!refresh_token) {
        signOut()
        return undefined
      }
      let response
      try {
        // Não deve fazer o login se for a rota para trocar o gestor
        if (!pathName.includes(trocaGestorPath)) {
          response = await client.post('/auth', {
            refresh_token,
          })
          signIn({
            ...response.data,
            user: localStorage.getItem(`${chave}:user`),
          })
        }
      } catch (e) {
        signOut()
        return Promise.reject(e)
      }
      error.response.config.headers.authorization = `Bearer ${response.data.access_token}`
      client.defaults.headers.authorization = `Bearer ${response.data.access_token}`
      const result = await client(error.response.config)
      return Promise.resolve(result)
    }

    if (
      error.response?.data?.message === 'celebrate request validation failed'
    ) {
      return Promise.reject(
        new Error(
          error.response?.data?.validation?.query?.message ||
            error.response?.data?.validation?.body?.message ||
            error.message,
        ),
      )
    }

    if (error?.response?.data.statusValidation) {
      return await Promise.reject(
        new StatusValidationError(
          error.response?.data?.message,
          error.response?.data?.statusValidation,
        ),
      )
    }

    if (error instanceof StatusValidationError) {
      return Promise.reject(error)
    }

    return await Promise.reject(
      new Error(error.response?.data?.message || error.message),
    )
  })
}
export class ServiceConfig {
  public async get<T, B, R = AxiosResponse<T>>(
    url: string,
    data?: B,
  ): Promise<R> {
    try {
      return await client.get(url, data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  public async post<T, B, R = AxiosResponse<T>>(
    url: string,
    data?: B,
    config?: AxiosRequestConfig,
  ): Promise<R> {
    try {
      return await client.post(url, data, config)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  public async put<T, B, R = AxiosResponse<T>>(
    url: string,
    data?: B,
  ): Promise<R> {
    try {
      return await client.put(url, data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  public async delete<T, B, R = AxiosResponse<T>>(
    url: string,
    data?: B,
  ): Promise<R> {
    try {
      return await client.delete(url, data)
    } catch (error) {
      return Promise.reject(error)
    }
  }

  public async patch<T, B, R = AxiosResponse<T>>(
    url: string,
    data?: B,
  ): Promise<R> {
    try {
      return await client.patch(url, data)
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default new ServiceConfig()
